import { useField } from 'vee-validate';
import MessageField from './MessageField.vue';
import RatingField from './RatingField.vue';
import { computed } from 'vue';
import EmailField from './EmailField.vue';


export default {
  __name: 'FormBody',
  props: {
    isSubmitting: Boolean,
    status: String,
},
  setup(__props, { expose }) {
  expose();

const props = __props;



const { value } = useField('rating');
const { value: message } = useField('message');
const { value: email } = useField('email');

const showFields = computed(() => {
    return value.value && Number(value.value) < 5;
});

const isButtonEnabled = computed(() => {
    return message.value.length > 0 && email.value.length > 0;
});
const url = jsData.siteUrl;

const __returned__ = { props, value, message, email, showFields, isButtonEnabled, url, get useField() { return useField }, MessageField, RatingField, computed, EmailField }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}